import React, { useState } from "react";
import { useFilial } from "../context/FilialContext";
import { useAuth } from "../context/AuthContext";
import { Building2, ChevronDown, Check } from "lucide-react";

export const FilialSelector = () => {
  const { user } = useAuth();
  const { filiais, selecionada, filialAtual, isDiretor, setSelecionada } = useFilial();
  const [open, setOpen] = useState(false);

  if (!user || user.role === "cliente") return null;
  if (filiais.length === 0) return null;

  // Operador: apenas exibe filial fixa
  if (!isDiretor) {
    const minha = filiais[0];
    return (
      <div
        className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-gray-100 text-gray-700 text-xs border"
        data-testid="filial-badge-fixo"
      >
        <span
          className="w-2 h-2 rounded-full"
          style={{ background: minha?.cor || "#F97316" }}
        />
        <Building2 size={12} />
        <span className="font-semibold">{minha?.sigla}</span>
        <span className="hidden lg:inline text-gray-500">· {minha?.cidade}</span>
      </div>
    );
  }

  // Diretor: dropdown completo
  const label = filialAtual ? `${filialAtual.sigla} · ${filialAtual.cidade}` : "Todas as filiais";

  return (
    <div className="relative" data-testid="filial-selector">
      <button
        onClick={() => setOpen((s) => !s)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-800 text-xs border transition"
        data-testid="filial-selector-toggle"
      >
        <span
          className="w-2 h-2 rounded-full"
          style={{ background: filialAtual?.cor || "#F97316" }}
        />
        <Building2 size={12} />
        <span className="font-semibold">{label}</span>
        <ChevronDown size={12} />
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 w-72 bg-white text-gray-900 rounded-lg shadow-2xl border overflow-hidden z-50"
          data-testid="filial-dropdown"
          onMouseLeave={() => setOpen(false)}
        >
          <button
            onClick={() => { setSelecionada(""); setOpen(false); }}
            data-testid="filial-opt-todas"
            className="w-full flex items-center justify-between px-4 py-2.5 text-sm hover:bg-orange-50 transition"
          >
            <span className="flex items-center gap-2 font-semibold">
              <Building2 size={14} /> Todas as filiais
            </span>
            {!selecionada && <Check size={14} className="text-orange-500" />}
          </button>
          <div className="border-t" />
          {filiais.map((f) => (
            <button
              key={f.id}
              onClick={() => { setSelecionada(f.id); setOpen(false); }}
              data-testid={`filial-opt-${f.sigla.toLowerCase()}`}
              className="w-full flex items-center justify-between px-4 py-2.5 text-sm hover:bg-orange-50 transition"
            >
              <span className="flex items-center gap-2">
                <span
                  className="w-3 h-3 rounded-full"
                  style={{ background: f.cor }}
                />
                <span className="font-medium">{f.sigla}</span>
                <span className="text-gray-500">· {f.cidade}</span>
              </span>
              {selecionada === f.id && <Check size={14} className="text-orange-500" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
